<template>
  <div class="register">
    <upload-action
      :docUrl="docUrl"
      :checkFlag="checkFlag"
      :type="type"
      v-if="type !== null"
      @uploadSuccess="uploadSuccess"
    ></upload-action>
    <iframe
      v-if="docUrl"
      style="width: 100%; min-height: 600px"
      :src="`https://view.officeapps.live.com/op/embed.aspx?src=${docUrl}`"
      width="100%"
      height="100%"
      frameborder="0"
    ></iframe>
    <!-- <iframe
      style="width: 100%; min-height: 600px"
      src="https://view.officeapps.live.com/op/view.aspx?src=http://videos.jxjycn.cn/DownLoad/xxzl/20170325/播音学概论.doc&amp;wdStartOn=1&amp;wdPrint=0&amp;wdEmbedCode=0"
      width="100%"
      height="100%"
      frameborder="0"
    ></iframe> -->
    <!-- <iframe
      src="https://view.officeapps.live.com/op/embed.aspx?src=http%3A%2F%2Fvideos%2Ejxjycn%2Ecn%3A80%2FDownLoad%2Fxxzl%2F20170325%2F%25E6%2592%25AD%25E9%259F%25B3%25E5%25AD%25A6%25E6%25A6%2582%25E8%25AE%25BA%2Edoc&amp;wdStartOn=1&amp;wdPrint=0&amp;wdEmbedCode=0"
      width="476px"
      height="288px"
      frameborder="0"
      >这是嵌入
      <a target="_blank" href="https://office.com">Microsoft Office</a> 文档，由
      <a target="_blank" href="https://office.com/webapps">Office</a>
      提供支持。</iframe
    > -->
  </div>
</template>

<script>
import uploadAction from "./uploadAction";
export default {
  components: {
    uploadAction,
  },
  name: "StartSchool",
  created() {
    this.getDoc();
  },
  data() {
    return {
      docUrl: null,
      checkFlag: true,
      type: null,
    };
  },
  methods: {
    getDoc() {
      this.axios.get(`/biz/archive/doc/get?type=0`).then((res) => {
        if (res.success) {
          if (res.result.length === 0) {
            this.docUrl = "";
            this.checkFlag = false;
            this.type = 0;
          } else {
            this.docUrl = res.result[0].docUrl ? res.result[0].docUrl : "";
            this.checkFlag = res.result[0].checkTime ? true : false;
            this.type = res.result[0].docType ? res.result[0].docType : 0;
            this.$emit('listEvent',this.checkFlag)
          }
        }
      });
    },
    uploadSuccess() {
      this.getDoc();
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.register {
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 20px;
}

.table {
  border-right: 1px solid #f2f2f2;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 0;
}

.table th {
  font-size: 15px;
  background: $bgcontent;
  font-weight: normal;
  border-left: 1px solid #f2f2f2;
  border-right: 1px solid #f2f2f2;
  vertical-align: center;
  color: #888;
}

.toptitle {
  text-align: center;
  font-size: 24px;
  font-weight: bold !important;
  line-height: 44px;
  color: #333 !important;
}

.sign {
  input {
    background: none;
    border: none;
  }

  .col-md-1 {
    padding-right: 0;
  }
}

.btn {
  background: $bgColor;
  color: #fff;
  width: 120px;
  margin: 20px;
}

.btn-text {
  color: #c4c4c4;
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/StartSchool.vue